(function () {

    angular
        .module('smartertoolsApp')
        .controller('ordersController', ['$scope', '$log', 'myAccountService', ordersController]);

    function ordersController($scope, $log, myAccountService) {
        var vm = this;

        activate();

        // -----------------------------------------------

        function activate() {
        }
    }

})();